import { initializeApp } from "firebase/app";
import { signOut, initializeAuth, browserLocalPersistence, browserPopupRedirectResolver, getAuth, GoogleAuthProvider, signInWithEmailAndPassword, GithubAuthProvider, signInWithPopup, signInWithRedirect, getRedirectResult, onAuthStateChanged  } from "firebase/auth";
import { getDB, getConfig, totCoffee, getCredit, showCoffee, todayCoffee, updateBalance, getUser, saveWebPushSubscription, getWebPushSubscriptions, deleteWebPushSubscription } from "./data/data.js";
import { getInboxMessages, addInboxMessage } from "/src/data/inbox.js";
import { UAParser } from 'ua-parser-js';
import { showSection } from "/src/navigation.js";
import  { PRICE } from '/src/minesweeper.js';
import { getPodImage } from '/src/pods.js';

const environment = import.meta.env.VITE_ENV.toLowerCase();

var authInfo = null;
var curUser = null;
var me = null;
var ui = null;
var app = null;
var auth = null;

function getAuthDomain() {
  return import.meta.env.VITE_AUTH_DOMAIN;
}

function getSignInFlow() {
  if (window.location.protocol == "http:") {
    // Per sviluppo locale vanno usati i popup dato che non viene utilizzato https
    return "popup";
  } else {
    // Per accesso da internet si utilizzano i redirect che forniscono un'esperienza utente migliore
    return "redirect";
  }
}



// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDMia8Ea3PFzNo__6qUH0pqm9uKppYIsJI",
    //dominio progetto coffee su firebase (per sviluppo locale)
    //authDomain: "coffee-41c4a.firebaseapp.com",
    //dominio nginx su google cloud run (per accesso da internet)
    //authDomain: "coffee-858231188760.europe-west6.run.app", 
    authDomain: getAuthDomain(),
    projectId: "coffee-41c4a",
    storageBucket: "coffee-41c4a.firebasestorage.app",
    //messagingSenderId: "858231188760",
    appId: "1:858231188760:web:e3fc7c0fa26573fbf0426d"
};

const PUBLIC_KEY = "BD5cKE0p5XT79MQODKAyvwZx6MNOCg8DkYJCalNhKnUCQmAo3WPi6Of0og_Wpcam_Bf6WDtwBnl-pIktM24LYJU";

async function webpushCheckSubscription(user, environment) {
    const db = getDB();
    return getWebPushSubscriptions(db, user, environment).then(subsctiptions => {

      //console.debug("subsctiptions");
      //for (var i=0; i<subsctiptions.length; i++) {
      //  console.debug("- %s", subsctiptions[i]);
      //}

      console.log("💬 ❌❌❌❌❌❌❌❌ %o", navigator.serviceWorker.controller);

      return navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {
        // Do we already have a push message subscription?
        return serviceWorkerRegistration.pushManager.getSubscription().then((subscription) => {
          if (!subscription) {
            console.log("💬 The user is not subscribed");
            return false;
          }  else{
            //check if user was subscribed with a different key
            let json = subscription.toJSON();
            let public_key = json.keys.p256dh;
            
            console.log("💬 Current subscription was done with key: '%s'", public_key);
            
            if (!subsctiptions.includes(public_key)) {
              console.log("💬 The user was subscribed with another key");
              subscription.unsubscribe().then(successful => {
                // You've successfully unsubscribed
                //subscribe(registration);
                console.log("💬 You've successfully unsubscribed");
              }).catch(e => {
                // Unsubscription failed
                console.log("💬 Unsubscription failed");
              });
              return false;
            } else {
              console.log("💬 Current subscription is ok !!");
              return true;
            }
          }
        }).catch((err) => {
            console.error(`💬 Error checking subscription: ${err}`);
        });
      });
    });
}

async function webpushUnsubscribeUser(user, environment) {
    navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {
    // Do we already have a push message subscription?
    serviceWorkerRegistration.pushManager.getSubscription().then((subscription) => {
        if (!subscription) {
            // We aren't subscribed to push
            console.log("💬 The user was never subscribed");
            return true;
        }  else{
            //check if user was subscribed with a different key
            let json = subscription.toJSON();
            let public_key = json.keys.p256dh;

            subscription.unsubscribe().then(successful => {
                // You've successfully unsubscribed
                //subscribe(registration);
                console.log("💬 You've successfully unsubscribed");
                const db = getDB();
                deleteWebPushSubscription(db, user, environment, public_key).then(xx => {
                  console.log("💬 Subscripton deleted form db");
                });
            }).catch(e => {
                // Unsubscription failed
                console.log("💬 Unsubscription failed %o", e);
            });   
        }     
    }).catch((err) => {
        console.error(`💬 Error during getSubscription(): ${err}`);
    });
  });
}

async function verifySubscription(key) {
    navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {
    // Do we already have a push message subscription?
    serviceWorkerRegistration.pushManager.getSubscription().then((subscription) => {
        if (!subscription) {
            // We aren't subscribed to push
            console.log("💬 The user was never subscribed");
            return;
        }  else{
                //check if user was subscribed with a different key
                let json = subscription.toJSON();
                let public_key = json.keys.p256dh;
                
                console.log(public_key);
                
                if(public_key != key){
                    console.log("💬 The user was subscribed with another key");
                    subscription.unsubscribe().then(successful => {
                        // You've successfully unsubscribed
                        //subscribe(registration);
                        console.log("💬 You've successfully unsubscribed");
                    }).catch(e => {
                        // Unsubscription failed
                        console.log("💬 Unsubscription failed");
                    })
                }
            }
        }).catch((err) => {
            console.error(`💬 Error during getSubscription(): ${err}`);
        });
    });
}

function newSubscription(user, environment, registration, key) {
    console.debug(registration)
    console.debug(registration.pushManager)
    registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key}).then((sub) => {
        console.debug("💬 Subscription Endpoint: " + sub.endpoint);
        var json = sub.toJSON();
        console.debug("💬 Subscription: ");
        console.debug(json);
        console.debug(JSON.stringify(sub));
        let sub64 = btoa(JSON.stringify(sub));

        const parser = new UAParser(navigator.userAgent);
        const result = parser.getResult();
        var platform = result.browser.name + " (" + result.browser.major + ") on " + result.os.name + " " + result.os.version;
        const db = getDB();
        saveWebPushSubscription(db, user, environment, JSON.stringify(sub), platform);
    },(error) => {
        // During development it often helps to log errors to the
        // console. In a production environment it might make sense to
        // also report information about errors back to the
        // application server.
        console.error("💬 %o", error);
    });
}

let webpushSubscribeUser = function(user, environment) {
    verifySubscription(PUBLIC_KEY).then(()=> {
        navigator.serviceWorker.getRegistrations().then(function(registrations) {
            for(let registration of registrations) {
                newSubscription(user, environment, registration, PUBLIC_KEY);
            };
        });
    });
}


function loginOk(loggedInUser, postLoginAction) {
  // User successfully signed in.
  // Return type determines whether we continue the redirect automatically
  // or whether we leave that to developer to handle.
  //authInfo = authResult;
  curUser = loggedInUser;

  //console.debug("signInSuccessWithAuthResult");
  //console.debug(authResult.credential.providerId);
  //console.debug(authResult.user.email);s

  const db = getDB();
  getConfig(db);
  me = getUser(db, curUser).then((u) =>  {
  //me = getUser(db, "pippo").then((u) =>  {
      me = u;
      //console.debug("me:");
      //console.debug(me);
      document.querySelectorAll('.user').forEach((cur) => {
        //console.debug(cur);
        cur.innerText = me.alias;
      });          
      if (me.image != null && me.image != "") {
          //document.getElementById('user-img').src = me.image;
          document.querySelectorAll('.user-img').forEach((cur) => {
            cur.src = me.image;
            cur.classList.remove('default');
          });          
      } 

      if (!me.roles.includes("member")) {
          showSection("unauthorized");
      } else {
          updateBalance(db, curUser, "#credit", "#credit-coffee");
          totCoffee(db, curUser).then(tot => {
              if (tot.totOffer >= PRICE) {
                  $("#minesweeper-show").css("display", "block");
              }
          });

          todayCoffee(db, curUser).then(list => {
              const home = document.getElementById("coffee-home");
              home.balance = me.balance;
              home.today = list;
              home.images = {
                "drank": getPodImage(me.color_drink),
                "offered": getPodImage(me.color_offer), 
                "marked":  getPodImage(me.color_mark), 
              };
          });
          showCoffee(db, curUser);

          console.debug("🙍🏻‍♂️ ROLES %o", me.roles);
          if (!me.roles.includes("admin")) {
              console.info("Disabling admin menu ...");
              var admins = document.getElementsByClassName('admin-only');
              for (var i = 0; i < admins.length; i++) {
                console.debug(admins[i]);
                admins[i].classList.add('disabled');
                admins[i].setAttribute("href", "#");
              }
          } 

          document.getElementById('main').style.display = 'inline';

          const nav = document.getElementById("bottom-nav");
          nav.user = me;

          getInboxMessages(db, curUser, environment).then(notifications => {
            const inbox = document.getElementById("notification-inbox");
            inbox.notifications = notifications;

            nav.setBadge("inbox", inbox.unreadCount);
          });

          if (postLoginAction) {
            console.log("⚡ Custom postLoginAction");
            postLoginAction();
          } else {
            console.log("⚡ Default postLoginAction");
            showSection("home");
          }
      }
  }).catch((e) => {
      console.info("Unautorized user !!");
      console.info(e);

      showSection("unauthorized");
  });
}

// FirebaseUI config.
////var uiConfig = {
////    signInOptions: [
////    // Leave the lines as is for the providers you want to offer your users.
////    GoogleAuthProvider.PROVIDER_ID,
////    GithubAuthProvider.PROVIDER_ID,
////    //firebase.auth.GoogleAuthProvider.PROVIDER_ID,
////    //firebase.auth.FacebookAuthProvider.PROVIDER_ID,
////    //firebase.auth.TwitterAuthProvider.PROVIDER_ID,
////    //firebase.auth.GithubAuthProvider.PROVIDER_ID,
////    //{
////    //  provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
////    //  requireDisplayName: false
////    //},
////    //ti.chfirebase.auth.PhoneAuthProvider.PROVIDER_ID,
////    //firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID
////    ],
////    immediateFederatedRedirect: false,
////    // popup (per sviluppo locale) - redirect (per accesso da internet)
////    //signInFlow: 'popup',
////    //signInFlow: 'redirect',
////    signInFlow: getSignInFlow(),
////    signInSuccessUrl: '/index.html',
////    // tosUrl and privacyPolicyUrl accept either url string or a callback
////    // function.
////    // Terms of service url/callback.
////    tosUrl: function() {
////      window.location.assign('/tos.html');
////    },
////    // Privacy policy url/callback.
////    privacyPolicyUrl: function() {
////    window.location.assign('/pp.html');
////    },
////    callbacks: {
////      signInSuccessWithAuthResult: function(authResult, redirectUrl) {
////        loginOk(authResult.user.email);
////
////        return false;
////      },
////      signInFailure: function(error) {
////        console.error("signInFailure");
////        return handleUIError(error);
////      },
////      uiShown: function() {
////        document.getElementById('loader').style.display = 'none';
////      }
////    }
////};

function logout() {
    signOut(auth);
    //window.location.href = window.location.href;
    location.reload();
}

function start(postLoginAction) {
  console.debug("🙍🏻‍♂️ Staring authentication ...");
  // Initialize Firebase
  app = initializeApp(firebaseConfig);



  var authConfig = {
    persistence: [browserLocalPersistence],
    popupRedirectResolver: browserPopupRedirectResolver,
  };

  if (import.meta.env.VITE_ENV == "DEV") {
    authConfig = {
      persistence: [browserLocalPersistence],
      popupRedirectResolver: browserPopupRedirectResolver
    };
  }
  auth = initializeAuth(app, authConfig);


  ////getRedirectResult(auth)
  ////  .then((result) => {
  ////    console.log("🙍🏻‍♂️ Returning after redirect ... ");
  ////
  ////    // This gives you a Google Access Token. You can use it to access Google APIs.
  ////    const credential = GoogleAuthProvider.credentialFromResult(result);
  ////    const token = credential.accessToken;
  ////
  ////    // The signed-in user info.
  ////    const user = result.user;
  ////    // IdP data available using getAdditionalUserInfo(result)
  ////    // ...
  ////  }).catch((error) => {
  ////    console.log("🙍🏻‍♂️ Returning with errors after redirect .. ");
  ////    console.log("🙍🏻‍♂️ -> %o", error);
  ////
  ////    // Handle Errors here.
  ////    const errorCode = error.code;
  ////    const errorMessage = error.message;
  ////    // The email of the user's account used.
  ////    //const email = error.customData.email;
  ////    // The AuthCredential type that was used.
  ////    const credential = GoogleAuthProvider.credentialFromError(error);
  ////    // ...
  ////    //console.log("🙍🏻‍♂️ -> %s - %s ", errorCode, errorMessage);
  ////    //console.log("🙍🏻‍♂️ -> %o", credential);
  ////  });



  auth.onAuthStateChanged((user) => {
    if (user) {
      console.info("🙍🏻‍♂️ User " + user.email + " is signed-in ...");
      //console.debug(user);

      loginOk(user.email, postLoginAction);
    } else {
      console.info("🙍🏻‍♂️ User is not logged in.");

      console.info("🙍🏻‍♂️ Starting login with 🇬Google provider ... ");
      const provider = new GoogleAuthProvider();
      
      
      //if (window.location.protocol == "xxhttp:") {
      if (import.meta.env.VITE_AUTH_MODE == "POPUP") {
        //per sviluppo locale
        console.log("🙍🏻‍♂️ Signing in with popup .. ");
        signInWithPopup(auth, provider).then((result) => {
          // This gives you a Google Access Token. You can use it to access the Google API.
          const credential = GoogleAuthProvider.credentialFromResult(result);
          const token = credential.accessToken;
          // The signed-in user info.
          const user = result.user;
          // IdP data available using getAdditionalUserInfo(result)
          // ...
        }).catch((error) => {
          // Handle Errors here.
          const errorCode = error.code;
          const errorMessage = error.message;
          console.error(error.message);
          console.error(error);
          // The email of the user's account used.
          const email = error.customData.email;
          // The AuthCredential type that was used.
          const credential = GoogleAuthProvider.credentialFromError(error);
          // ...
        });
      } else {
        // Per accesso da internet si utilizzano i redirect che forniscono un'esperienza utente migliore
        console.log("🙍🏻‍♂️ Signing in with redirect .. ");
        signInWithRedirect(auth, provider);
      }

      
    }
  });

}

async function getToken() {
  if (!auth.currentUser) {
      throw new Error('🙍🏻‍♂️ Not authenticated. Make sure you\'re signed in!');
  }

  // Get the Firebase auth token to authenticate the request
  return auth.currentUser.getIdToken().then(function(token) {
    return token;
  });
}

export {start, firebaseConfig, app, auth, ui, authInfo, curUser, me, logout, webpushSubscribeUser, webpushCheckSubscription, webpushUnsubscribeUser, getToken }
